import React from 'react';

import styles from './index.module.css'
import card_1_img from '../../assets/images/bonuses/card-1.png';
import card_2_img from '../../assets/images/bonuses/card-2.png';
import card_3_img from '../../assets/images/bonuses/card-3.png';


const Bonuses = () => {
    return (
        <div className='inner-container'>
            <div className="container">
                <h1 className="title text-center">Casino <span className='text-primary'>Bonuses</span></h1>
                <p className='text-center'>Find my all casino bonuses here</p>
            </div>
            <div className="container">
                <div className="row">
                    <div className="col-md-4">
                        <div className={`${styles.card} card my-2 card-pink`}>
                            <div className={`${styles.cardImgTopWrapper} m-auto`}>
                                <img src={card_1_img} className={`${styles.cardImgTop} card-img-top mw-100`} alt="..." />
                            </div>
                            <div className="card-body">
                                <h5 className="fw-bold text-center">100% Deposit Bonus</h5>
                                <div className="card-text">Bonus Conditions:
                                    <ul>
                                        <li>
                                            Use code <span className="text-primary fw-bold">"SEBM"</span> on Sign Up
                                        </li>
                                        <li>
                                            Deposit Between $20-$500
                                        </li>
                                        <li>
                                            Wager the Bonus 40x
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <a href="#" className="btn btn-primary mt-2">Claim Bonus</a>
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className={`${styles.card} card my-2 card-blue`}>
                            <div className={`${styles.cardImgTopWrapper} m-auto`}>
                                <img src={card_2_img} className={`${styles.cardImgTop} card-img-top mw-100`} alt="..." />
                            </div>
                            <div className="card-body">
                                <h5 className="fw-bold text-center">100% Deposit Bonus + 125 FS</h5>
                                <div className="card-text">Bonus Conditions:
                                    <ul>
                                        <li>
                                            Use code <span className="text-primary fw-bold">"SEBM"</span> on Sign Up
                                        </li>
                                        <li>
                                            Deposit Between $20-$500
                                        </li>
                                        <li>
                                            Wager the Bonus 30x
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <a href="#" className="btn btn-primary mt-2">Claim Bonus</a>
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className={`${styles.card} card my-2 card-yellow`}>
                            <div className={`${styles.cardImgTopWrapper} m-auto`}>
                                <img src={card_3_img} className={`${styles.cardImgTop} card-img-top mw-100`} alt="..." />
                            </div>
                            <div className="card-body">
                                <h5 className="fw-bold text-center">100% Deposit Bonus</h5>
                                <div className="card-text">Bonus Conditions:
                                    <ul>
                                        <li>
                                            Use code <span className="text-primary fw-bold">"SEBM"</span> on Sign Up
                                        </li>
                                        <li>
                                            Deposit Between $20-$500
                                        </li>
                                        <li>
                                            Wager the Bonus 40x
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <a href="#" className="btn btn-primary mt-2">Claim Bonus</a>
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className={`${styles.card} card my-2 card-pink`}>
                            <div className={`${styles.cardImgTopWrapper} m-auto`}>
                                <img src={card_1_img} className={`${styles.cardImgTop} card-img-top mw-100`} alt="..." />
                            </div>
                            <div className="card-body">
                                <h5 className="fw-bold text-center">100% Deposit Bonus</h5>
                                <div className="card-text">Bonus Conditions:
                                    <ul>
                                        <li>
                                            Use code <span className="text-primary fw-bold">"SEBM"</span> on Sign Up
                                        </li>
                                        <li>
                                            Deposit Between $20-$500
                                        </li>
                                        <li>
                                            Wager the Bonus 40x
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <a href="#" className="btn btn-primary mt-2">Claim Bonus</a>
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className={`${styles.card} card my-2 card-blue`}>
                            <div className={`${styles.cardImgTopWrapper} m-auto`}>
                                <img src={card_2_img} className={`${styles.cardImgTop} card-img-top mw-100`} alt="..." />
                            </div>
                            <div className="card-body">
                                <h5 className="fw-bold text-center">100% Deposit Bonus + 125 FS</h5>
                                <div className="card-text">Bonus Conditions:
                                    <ul>
                                        <li>
                                            Use code <span className="text-primary fw-bold">"SEBM"</span> on Sign Up
                                        </li>
                                        <li>
                                            Deposit Between $20-$500
                                        </li>
                                        <li>
                                            Wager the Bonus 30x
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <a href="#" className="btn btn-primary mt-2">Claim Bonus</a>
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className={`${styles.card} card my-2 card-yellow`}>
                            <div className={`${styles.cardImgTopWrapper} m-auto`}>
                                <img src={card_3_img} className={`${styles.cardImgTop} card-img-top mw-100`} alt="..." />
                            </div>
                            <div className="card-body">
                                <h5 className="fw-bold text-center">100% Deposit Bonus</h5>
                                <div className="card-text">Bonus Conditions:
                                    <ul>
                                        <li>
                                            Use code <span className="text-primary fw-bold">"SEBM"</span> on Sign Up
                                        </li>
                                        <li>
                                            Deposit Between $20-$500
                                        </li>
                                        <li>
                                            Wager the Bonus 40x
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <a href="#" className="btn btn-primary mt-2">Claim Bonus</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Bonuses;
